 let getters = {
        mvpds: state=>{
        	return state.mvpds
        },
        errors: state=>{
        	return state.errors
        },
    	currentRebate: state=>{
        	//return state.currentRebate
        }
    }

   export default getters

